import React from 'react';
import styled from 'styled-components';
import { MediaQuery, Palette } from 'core/config';
import { useAppContext } from 'core/context';
import { useContactUsNav } from 'view/hooks';

export const FixedButton: React.FunctionComponent<{ children: React.ReactNode }> = ({ children }) => 
{
    const { navbarIsExpanded } = useAppContext();
    const goToContactUs = useContactUsNav();

    const handleClick = () => 
    {
        goToContactUs({ intent: 'work-with-us' });
    };

    return !navbarIsExpanded ? <Container onClick={handleClick}> {children} </Container> : null;
};

const Container = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;

    width: 167px;
    height: 48px;
    box-sizing: border-box;
    border-radius: 500px;

    border: 2px solid ${Palette.DARK_GRAY};
    background-color: ${Palette.DARK_GRAY};
    color: ${Palette.WHITE};

    font-family: 'Poppins-Light';
    font-size: 17px;

    cursor: pointer;
    transition: opacity 1s ease-in-out;

    :hover {
        background-color: ${Palette.WHITE};
        color: ${Palette.DARK_GRAY};
    }

    @media ${MediaQuery.tablet} {
        font-family: 'Poppins-Regular';
    }
`;
